import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Attempt, Lifter, Meet, Platform } from "types";
import { useDisplaySettings } from "./DisplaySettingsProvider";
import FastMarquee from "react-fast-marquee";
import capitalize from "lodash/capitalize";
import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc,
} from "util/lifterHelper";
import { getManuallySetRecord } from "./RecordInfo";
import { useRecordAttempts } from "util/useRecordAttempts";
import { formatLongEligibleRecord } from "util/records";
import { getPositionChange } from "./PositionChange";

const EDIT_MODE_TEXT =
  "John Doe • Red Team • Squat 1 • 400kg • Men's Open • RECORD ATTEMPT: WORLD : FULL-POWER : SQUAT : M1 : 63kg";

const Marquee = ({
  meet,
  currentLifter,
  currentAttempt,
  id,
  platform,
  barChangeEvent,
}: {
  meet: Meet;
  currentLifter: Lifter | undefined | null;
  currentAttempt: Attempt;
  platform: Platform;
  id: string;
  barChangeEvent: boolean;
}) => {
  const { editMode, marqueeSpeed } = useDisplaySettings();

  let marqueeText = "";
  if (currentLifter) {
    marqueeText = marqueeText + currentLifter.name;
    if (currentLifter.team) {
      marqueeText = marqueeText + " • " + currentLifter.team;
    }
  }

  const allRecords = useRecordAttempts();

  if (currentAttempt) {
    marqueeText =
      marqueeText +
      ` • ${capitalize(currentAttempt.liftName)} ${currentAttempt.attemptNumber} ${currentAttempt.weight} ${meet.units?.toLowerCase()}`;

    const manualRecord = getManuallySetRecord(currentAttempt);

    if (manualRecord) {
      marqueeText = marqueeText + " • " + manualRecord;
    }

    const recordsForAttempt = allRecords?.[currentAttempt._id];
    const autoRecordsText = recordsForAttempt
      ?.map((record) => {
        const recordText = formatLongEligibleRecord({
          record,
        });

        return recordText;
      })
      .join(" : ");

    if (autoRecordsText) {
      marqueeText = marqueeText + " • " + autoRecordsText;
    }
  }

  if (currentLifter) {
    marqueeText =
      marqueeText +
      " • " +
      currentLifter.divisions
        .map((lifterDivision) => {
          const division = getDivisionDoc(lifterDivision.divisionId, meet);
          if (division) {
            const weightClass = getLifterAwardsWeightClassDoc(
              meet,
              currentLifter,
              lifterDivision,
            );

            if (weightClass) {
              return `${division.name} ${weightClass.name?.toLowerCase() === "all" ? "" : weightClass.name}`;
            }
          }
          return "";
        })
        .join(" : ");
  }

  if (currentLifter && currentAttempt) {
    const positionChange = getPositionChange({
      meet,
      currentAttempt,
      currentLifter,
    });
    if (positionChange) {
      marqueeText = marqueeText + ` • ${positionChange}`;
    }
  }

  let text = editMode ? EDIT_MODE_TEXT : marqueeText;

  if (platform.attemptChangeInProgress) {
    text = "ATTEMPT CHANGE IN PROGRESS";
  }

  if (barChangeEvent) {
    text = `Bar change needed. Change to ${platform.barAndCollarsWeight} ${meet.units?.toLowerCase()} bar + collars.`;
  }

  return (
    <DisplayComponent style={{ top: 830, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 28,
          width: "100vw",
        };

        return (
          <div style={style} className="lifter-details">
            <FastMarquee speed={marqueeSpeed} autoFill>
              <span className="marquee-content">{text}</span>
            </FastMarquee>
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default Marquee;
